module.exports = __webpack_public_path__ + "img/saas1-sector4.5e16abc3.png";